'use client';

import { Link } from '@coolblue-development/freddy';
import { ArrowRight } from '@coolblue-development/icons';
import { useProductInformation } from '@features/product/components/ProductInformation/ProductInformationContext';
import { useTranslation } from '@i18n/useTranslation';

export default function ProsAndConsModalLink() {
  const { openModal } = useProductInformation();
  const { t } = useTranslation('webshop.productPage.productInformation');

  return (
    <Link component='button' startIcon={<ArrowRight />} onClick={openModal} mt={200}>
      {t('allProsAndCons')}
    </Link>
  );
}
